import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { VersionModel } from '@/core/services/Maintenance/models/VersionModel'
import MaintenanceService from '@/core/services/Maintenance/MaintenanceService'

const initialState: VersionModel = {
  ...new VersionModel(),
}

export const versionThunk = createAsyncThunk(
  'version/versionThunk',
  async (_, { rejectWithValue }) => {
    try {
      return await MaintenanceService.getVersion()
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const versionSlice = createSlice({
  name: 'version',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(versionThunk.fulfilled, (state, action) => {
        state.databaseVersion = action.payload.databaseVersion
        state.lastDownloadCompanyResult =
          action.payload.lastDownloadCompanyResult
        state.lastExternalSync = action.payload.lastExternalSync
        state.lastSyncCompanyResult = action.payload.lastSyncCompanyResult
        state.lastsynclicense = action.payload.lastsynclicense
        state.version = action.payload.version
      })
      .addCase(versionThunk.rejected, state => {
        state.databaseVersion = ''
        state.lastDownloadCompanyResult = ''
        state.lastExternalSync = ''
        state.lastSyncCompanyResult = ''
        state.lastsynclicense = ''
        state.version = ''
      })
  },
})

export const { actions, reducer } = versionSlice
